// extracted by mini-css-extract-plugin
export default {"root":"RolePicker_root__XYhr1","label":"RolePicker_label__aqhF6","description":"RolePicker_description__vZcYl"};